import { Link, useLocation } from "react-router-dom";

const menuItems = [
  { label: "Dashboard", route: "/hr" },
  { label: "Employee Database", route: "/hr/employees" },
  { label: "Attendance & Time Tracking", route: "/hr/attendance" },
  { label: "Leave Management", route: "/hr/leave-management" },
  { label: "Recruitment & Onboarding", route: "/hr/recruitment" },
  { label: "Payroll Management", route: "/hr/payroll" },
  { label: "Performance Management", route: "/hr/performance" },
  { label: "Compliances & Reports", route: "/hr/compliances" },
  { label: "Separation", route: "/hr/separation" },
];

const SideBar = () => {

  const location = useLocation();

  return (
    <aside className="w-[260px] bg-gradient-to-b from-nav to-[#07305a] text-white flex flex-col justify-between py-7 px-[18px]">
      <div>
        {/* Logo */}
        <div className="font-bold text-xl mb-[18px]">NHWM HR</div>

        {/* Profile */}
        <div className="flex items-center gap-[10px] mb-[26px]">
          <div>
            <div className="text-md text-muted">HR Manager</div>
          </div>
        </div>

        {/* Menu */}
        <nav className="flex flex-col gap-2">
          {menuItems.map((item, idx) => (
            <Link
              key={idx}
              to={item.route}
              className={`px-[12px] py-[10px] rounded-lg text-sm font-bold ${
                location.pathname === item.route
                  ? "bg-[#fff3]"
                  : "hover:bg-[#fff3]"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>

      {/* Footer */}
      <div className="text-xs text-white">© 2025 NHWM • Secure HR Portal</div>
    </aside>
  );
};

export default SideBar;
